// Application main
function appInit($) {

'use strict';
console.log('jQuery Version is ' + $.fn.jquery);

// Common elements
var $window = $(window);
var $root = $('#root');
//var $header = $('#header');

// Window Size
var windowWidth = window.innerWidth;
var windowHeight = window.innerHeight;

// Breakpoint for responsive JS
var breakpoint = {
	tablet: 768,
	desktop: 1024,
}

/**
 * More Items set same height
 */
var $topMoreItems = $('.top-more-item');
if ($topMoreItems) {
	var topMoreItemMaxHeight = $topMoreItems.eq(3).outerHeight();
	$topMoreItems.each(function(index) {
		$(this).outerHeight(topMoreItemMaxHeight);
	});
}

/**
 * Contact form
 */
var $hasPlaceholders = $('.hasPlaceholder');
// focus
$hasPlaceholders.on('focus', function(e) {
	// console.log('Focus');
	var $this = $(e.target);
	$this.parent().parent().addClass('isFocus');
});
$hasPlaceholders.on('focusout', function(e) {
	var $this = $(e.target);
	$this.parent().parent().removeClass('isFocus');
});
// keyup
$hasPlaceholders.on('keyup', function (e) {
	var $this = $(e.target);
	if ( $this.val() ) {
		$this.parent().parent().addClass('hasValue');
	} else {
		$this.parent().parent().removeClass('hasValue');
	}
});

/**
 * Smooth scrolling
 */
$('a[href*="#"]:not([href="#"])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 1000);
			return false;
		}
	}
});

/**
 * CSS animation
 */
var $animationElements = $('[data-animation]');
var animationArray = [];

// Class for animation object
function AnimationElement (element, point) {
	this.el = element;
	this.point = point;
}

// Create array of AnimationElement objects
$animationElements.each(function () {
	var offsetTop = $(this).offset().top;
	var point = offsetTop - (windowHeight*0.75);
	var obj = new AnimationElement(this, point);
	animationArray.unshift( obj );
});

function animation () {
	// Get current scroll position
	var scrollTop = $window.scrollTop();
	for (var i = animationArray.length - 1, obj; obj = animationArray[i]; i--) {
		if ( scrollTop >= obj.point) {
			$(obj.el).addClass('animated');
			animationArray.splice(i, 1);
		}
	}
	//$(animationArray).each( function () {});

	// Off the scroll event if there is no more animation element.
	if (animationArray.length == 0) {
		console.log('Off custom animation');
		$window.off('scroll', animation);
	}
}

// Attach scroll event
$window.on('scroll', animation);

/**
 * Top triangles rotation
 */

var topTriangleArray = [];

function TopTriangle (element, height, offsetTop, inPoint, outPoint, direction) {
	this.el = $(element);
	this.height = height;
	this.offsetTop = offsetTop;
	this.inPoint = inPoint;
	this.outPoint = outPoint;
	this.direction = direction;
	this.duration = outPoint - inPoint;
}

// Create array of TopTriangle
var $topTriangles = $('.top-mission > img.triangle');
$topTriangles.each(function() {
	// Define values
	var $this = $(this);
	var _height = this.offsetHeight;
	var _offsetTop = $this.offset().top;
	var _inPoint = _offsetTop - windowHeight;
	var _outPoint = _offsetTop + _height;
	var _direction = $this.data('direction');
	_direction = parseInt(_direction);

	// Create TopTriangle object, then push
	var obj = new TopTriangle(this, _height, _offsetTop, _inPoint, _outPoint, _direction);
	topTriangleArray.push(obj);
});

// rotation animation
function traiangleAnimation() {
	var scrollTop = $window.scrollTop();
	for (var i = 0, obj; obj = topTriangleArray[i]; i++) {
		if (scrollTop > obj.inPoint && scrollTop <= obj.outPoint) {
			var deg = obj.direction * ((obj.outPoint-scrollTop)/obj.duration) * 180;
			obj.el.css({
				'-webkit-transform': 'rotate('+deg+'deg)',
				'-ms-transform': 'rotate('+deg+'deg)',
				'transform': 'rotate('+deg+'deg)'
			})
		}
	}
}
$window.on('scroll', traiangleAnimation);

} // End appInit

// Event on Pace done
function doneLoading($) {
	// Hide loading img
	$('#progressUI > img').hide();

	// Hide progress UI layer
	var $progressUI = $('#progressUI');
	$progressUI.css('opacity', 0);

	// Hero Logo Slide
	var $topHeader = $('#topHeader');
	if ($topHeader) {
		$topHeader.addClass('animated');
	}

	// 
	setTimeout( function () {
		$progressUI.css('display', 'none');
		$('html').removeClass('overflow-hidden');
		$(window).trigger('scroll');
	}, 750);
}

// Pace
Pace.on('done', function() {
	appInit(jQuery3);
	doneLoading(jQuery3);
}, false);